import cn from "classnames";
import React, { ReactNode, useEffect, useRef } from "react";
import styles from "./keyline-grid.css";

interface KeylineGridProps {
    children?: ReactNode;
    className?: string;
    fullWidth?: boolean;
}

export function KeylineGrid({
    children,
    className,
    fullWidth = false,
}: KeylineGridProps): JSX.Element {
    return (
        <div className={cn(styles.wrapper, className)}>
            <div className={cn(styles.grid, { [styles.fullWidth]: fullWidth })}>{children}</div>
        </div>
    );
}

interface KeylineGridItemProps {
    children: ReactNode;
    scrollIntoView?: boolean;
    className?: string;
}

export function KeylineGridItem({
    children,
    scrollIntoView = false,
    className,
}: KeylineGridItemProps): JSX.Element {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (scrollIntoView) {
            ref.current?.scrollIntoView();
        }
    }, [scrollIntoView]);

    return (
        <div ref={ref} className={cn(styles.item, className)}>
            {children}
        </div>
    );
}
